"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _reactNumberFormat = require("react-number-format");
var _TextField = _interopRequireDefault(require("@mui/material/TextField"));
var _styles = require("@mui/material/styles");
var _theme = require("../../theme");
var _fonts = _interopRequireDefault(require("../../theme/fonts"));
var _system = require("@mui/system");
var localizationMaps = _interopRequireWildcard(require("../../localization/maps"));
var _i18n = _interopRequireDefault(require("../../localization/i18n"));
var _excluded = ["inputRef", "onChange"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var StyledTextField = (0, _styles.styled)(_TextField["default"])(function (_ref) {
  var theme = _ref.theme;
  return {
    '& .MuiInputBase-root': {
      fontFamily: '"AvenirLTPro-Book", sans-serif',
      fontWeight: 400,
      color: theme.palette["default"].contrastText,
      letterSpacing: "0.14994px"
    },
    "& .MuiOutlinedInput-root:hover:not(.Mui-disabled):not(.Mui-error):before": {
      borderColor: theme.palette.custom.textFieldHover
    },
    "& .MuiInput-underline:hover:not(.Mui-disabled):not(.Mui-error):before": {
      borderColor: theme.palette.custom.textFieldHover,
      borderBottomWidth: "2px"
    }
  };
});

/**
 *
 * @param {*} props
 */
var DateFormatCustom = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var inputRef = props.inputRef,
    onChange = props.onChange,
    other = (0, _objectWithoutProperties2["default"])(props, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_reactNumberFormat.PatternFormat, (0, _extends2["default"])({}, other, {
    getInputRef: inputRef,
    onValueChange: function onValueChange(values) {
      onChange({
        target: {
          value: values.formattedValue
        }
      });
    },
    style: {
      backgroundColor: props.disabled ? '#f7f7f7' : null
    },
    format: "####/##/##",
    placeholder: _i18n["default"].locale === "en" ? "YYYY/MM/DD" : "AAAA/MM/JJ",
    mask: ['Y', 'Y', 'Y', 'Y', 'M', 'M', 'D', 'D']
  }));
});

/**
 *
 * @param {*} props
 */
var DateFormat = function DateFormat(props) {
  var theme = (0, _system.useTheme)();
  return /*#__PURE__*/_react["default"].createElement(StyledTextField, {
    id: props.id || props.testid,
    select: props.select,
    error: props.error,
    label: props.label,
    value: props.value,
    autoFocus: props.autoFocus,
    margin: props.margin || 'normal' // none, dense, or normal
    ,
    onChange: props.onChange,
    onKeyPress: props.onKeyPress,
    onBlur: props.onBlur,
    fullWidth: props.fullWidth,
    helperText: props.helperText || props.error,
    FormHelperTextProps: {
      style: _objectSpread({
        fontFamily: _fonts["default"].type.base
      }, props.customHelperTextProps)
    },
    InputLabelProps: {
      style: {
        color: theme.primary,
        fontFamily: _fonts["default"].type.light
      }
    },
    InputProps: {
      autoComplete: props.autoComplete || "off",
      inputComponent: DateFormatCustom
    },
    sx: _objectSpread(_objectSpread({
      backgroundColor: props.disabled && '#f7f7f7',
      letterSpacing: "0.14994px"
    }, props.customStyle), {}, {
      "& .MuiInputBase-input.Mui-disabled": {
        WebkitTextFillColor: _theme.colors.mainTextGrey
      }
    }),
    required: props.required,
    variant: props.variant || 'standard',
    disabled: props.disabled
  });
};
var _default = exports["default"] = DateFormat;